/**
* @constructor
* Implements a minimal tabList element
*
* @param {groupNode} groupNode
*/

export default function TabsManual(groupNode) {
	this.tablistNode = groupNode;

	this.tabs = [];

	this.firstTab = null;
	this.lastTab = null;

	this.tabs = Array.from(this.tablistNode.querySelectorAll('[role=tab]'));
	this.tabpanels = [];

	this.isMobile = false;

	this.toggleOverflowClass = (elem) => {
		elem.parentElement.classList.toggle('overflowing', elem.scrollWidth > elem.clientWidth);
		this.isMobile = elem.scrollWidth > elem.clientWidth;
	};

	this.setSelectedTab = (currentTab) => {
		for (let i = 0; i < this.tabs.length; i += 1) {
			const tab = this.tabs[i];
			if (currentTab === tab) {
				tab.setAttribute('aria-selected', 'true');
				tab.removeAttribute('tabindex');
				this.tabpanels[i].removeAttribute('hidden');
			} else {
				tab.setAttribute('aria-selected', 'false');
				tab.tabIndex = -1;
				this.tabpanels[i].setAttribute('hidden', '');
			}
		}
	};

	this.moveFocusToTab = (currentTab) => {
		currentTab.focus();
		// this.setSelectedTab(currentTab);
	};

	this.moveFocusToPreviousTab = (currentTab) => {
		let index;

		if (currentTab === this.firstTab) {
			this.moveFocusToTab(this.lastTab);
		} else {
			index = this.tabs.indexOf(currentTab);
			this.moveFocusToTab(this.tabs[index - 1]);
		}
	};

	this.moveFocusToNextTab = (currentTab) => {
		let index;

		if (currentTab === this.lastTab) {
			this.moveFocusToTab(this.firstTab);
		} else {
			index = this.tabs.indexOf(currentTab);
			this.moveFocusToTab(this.tabs[index + 1]);
		}
	};

	/* EVENT HANDLERS */

	this.keyboardManager = (e) => {
		const tgt = e.currentTarget;
		let flag = false;

		switch (e.key) {
			case 'Enter':
				this.setSelectedTab(tgt);
				break;

			case 'ArrowLeft':
				this.moveFocusToPreviousTab(tgt);
				flag = true;
				break;

			case 'ArrowRight':
				this.moveFocusToNextTab(tgt);
				flag = true;
				break;

			case 'Home':
				this.moveFocusToTab(this.firstTab);
				flag = true;
				break;

			case 'End':
				this.moveFocusToTab(this.lastTab);
				flag = true;
				break;

			default:
				break;
		}

		if (flag) {
			e.stopPropagation();
			e.preventDefault();
		}
	};

	this.onClick = (e) => {
		this.setSelectedTab(e.currentTarget);
	};

	this.init = () => {
		this.tabs.forEach((element) => {
			const tab = element;
			const tabpanel = document.getElementById(tab.getAttribute('aria-controls'));

			tab.tabIndex = -1;
			tab.setAttribute('aria-selected', 'false');
			this.tabpanels.push(tabpanel);

			tab.addEventListener('keydown', this.keyboardManager.bind(this));
			tab.addEventListener('click', this.onClick.bind(this));

			if (!this.firstTab) {
				this.firstTab = tab;
			}
			this.lastTab = tab;
		});

		this.setSelectedTab(this.firstTab);
		this.tablistNode.addEventListener('keydown', this.keyboardManager.bind(this));
		this.tabs.forEach((tab) => {
			tab.addEventListener('click', (e) => {
				this.setSelectedTab(e.currentTarget);
			});
		});
	};
}
